import React, { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { FairtreeTheme } from "../resources/theme";
import { useDispatch, useSelector } from "react-redux";

import { Box, Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";

import { BrowserRouter } from "react-router-dom";
import MainRoutes from "../main.routes";
import TitleProvider from "../providers/titleProvider";
import {
  clearAlert,
  clearAlertWithDelay,
  setAlertError,
} from "../features/alert/alert.slice";
import OnlineStatusProvider, {
  useOnlineStatus,
} from "../providers/onlineStatusProvider";

const ColorModeContext = React.createContext({ toggleColorMode: () => {} });

function App() {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const [mode, setMode] = useState(prefersDarkMode ? "dark" : "light");
  const theme = React.useMemo(() => FairtreeTheme(mode), [mode]);
  const { message, type, open } = useSelector((state) => state.alert);

  const onlineStatus = useOnlineStatus();
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("onlineStatus", onlineStatus);
    if (!onlineStatus) {
      dispatch(
        setAlertError("You are offline. Please check your internet connection.")
      );
      dispatch(clearAlertWithDelay());
    }
  }, [onlineStatus]);

  const handleClose = () => {
    dispatch(clearAlert());
  };

  useEffect(() => {
    setMode(prefersDarkMode ? "dark" : "light");
  }, [prefersDarkMode]);

  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    []
  );

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  return (
    <StyledEngineProvider injectFirst>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />

          <Snackbar
            open={open}
            autoHideDuration={null}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert
              sx={{ boxShadow: "none" }}
              onClose={handleClose}
              severity={type}
            >
              {message}
            </Alert>
          </Snackbar>

          <TitleProvider>
            <BrowserRouter>
              <MainRoutes />
            </BrowserRouter>
          </TitleProvider>

          {/* <Box>
            {onlineStatus ? null : (
              <Box
                sx={{
                  position: "fixed",
                  bottom: 0,
                  width: "100%",
                  backgroundColor: "error.main",
                  color: "error.contrastText",
                  textAlign: "center",
                  padding: "5px",
                  zIndex: 100,
                }}
              >
                You are offline. Please check your internet connection.
              </Box>
            )}
          </Box> */}
        </ThemeProvider>
      </ColorModeContext.Provider>
    </StyledEngineProvider>
  );
}

export default App;
